import { css } from '@emotion/react'
import { Button } from 'components/button/Button'
import { ContentfulImage } from 'components/Image'
import { LandingPageHero } from 'components/landingPageHero/LandingPageHero'
import { Spacer } from 'components/spacer/Spacer'
import { Text } from 'components/Typography'
import { FC } from 'react'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { useWindowSize } from 'utils/hooks'
import { formatTextWithLineBreaks } from 'utils/text/formatTextWithLineBreaks'

type Props = {
  title?: string
  description?: string
  image?: string
  cta?: string
  ctaDescription?: string
}

export const BusinessHero: FC<Props> = ({
  title,
  description,
  image,
  cta,
  ctaDescription,
}: Props) => {
  const images = useContentfulImages()
  const { isXLarge } = useWindowSize()
  return (
    <div>
      <LandingPageHero
        title={formatTextWithLineBreaks(title)}
        image={
          <ContentfulImage
            {...(image ? { url: image } : images.estate_planning_hero_pivot)}
            priority
          />
        }
        heroCSS={{ alignItems: 'center' }}
        tone="light-blue"
        overflowing={!isXLarge}
        mobileVariant="modern"
      >
        <Text variant="bodyLarge">{formatTextWithLineBreaks(description)}</Text>
        <Spacer size={1.5} />
        <Button
          type="button"
          size="large"
          href="#contact"
          css={css`
            @media (max-width: 1024px) {
              width: 100% !important;
            }
          `}
        >
          {cta}
        </Button>
        <Spacer size={1.5} />
        <Text variant="italic">{formatTextWithLineBreaks(ctaDescription)}</Text>
      </LandingPageHero>
    </div>
  )
}
